export default __webpack_public_path__ + "static/media/black_pawn.e0fe1e91.png";